import { useHistory } from 'react-router';
import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

// app
import { multipartAdminAxios } from '../../admin.api';
import { THIRD_PARTY_OFFICE_LIST, OPERATIONAL_THIRD_PARTY } from '../../queryKeys';
import * as utils from 'utils';
import config from 'config';
import { logoutAuth0 } from 'utils/auth0/auth0';
import { enqueueNotification, hideModal } from 'stores';

export const useCreateOperationalThirdParty = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const history = useHistory();

  const handleSettled = (data) => {
    dispatch(hideModal());
  };

  const handleError = (err) => {
    const errorParams = {
      file: 'admin.mutations.useCreateOperationalThirdParty',
      message: 'API fetch error (admin.post)',
    };
    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
    dispatch(enqueueNotification('notification.admin.parentClientPostFail', 'error'));
  };

  const handleSuccess = (res) => {
    const { data } = res;
    queryClient.invalidateQueries(OPERATIONAL_THIRD_PARTY);
    queryClient.invalidateQueries(THIRD_PARTY_OFFICE_LIST);

    history.push(`${config.routes.admin.operationalThirdParty}/${data?.id}`);

    dispatch(
      enqueueNotification('notification.admin.parentClientSuccess', 'success', {
        data: { clientName: data?.name },
      })
    );
  };

  return useMutation(
    async (newData) => {
      let form = new FormData();
      form.append('name', newData.name);
      if (!isEmpty(newData?.logo)) {
        newData.logo.forEach((logo) => form.append('logo', logo));
      }

      if (!utils.generic.isValidObject(newData)) {
        throw new Error('Invalid operational tpa request body');
      }

      return await multipartAdminAxios.post('v1/operational-third-party', form);
    },
    {
      onSuccess: (res) => handleSuccess(res),
      onError: (err) => handleError(err),
      onSettled: handleSettled,
    }
  );
};
